export var HP_OLX_TRACKING = {
  HP_EXCHANGE_BUY: 'exchange_buy_homepage',
  HP_EXCHANGE_SELL: 'exchange_sell_homepage',
  HP_CF_BUY: 'cf_buy_homepage',
  LISTINGS_RESULTS: 'listings_results'
};